import * as React from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import {
  PositionsContainer,
  Section,
  SectionImage,
  SectionTitle,
} from './serviceTeam.style';
import { CardWithTitleAndDescription } from '../Cards/CardWithTitleAndDescription/CardWithTitleAndDescription';

import Image from 'next/image';
import { imageSerializer } from '../../../utils/imageSerializer';
import { TitleType } from '../../../models/globalTypes/title';

interface IPosition {
  position: Array<RichTextBlock>;
  description: Array<RichTextBlock>;
}

interface IServiceTeamProps extends TitleType {
  positions: IPosition[];
  image: RichTextBlock;
}

export const ServiceTeam = (props: IServiceTeamProps) => {
  return (
    <Section>
      <SectionTitle as={props.titleAs}>{props.title}</SectionTitle>
      <PositionsContainer>
        {props.positions.map((position, index) => (
          <CardWithTitleAndDescription
            key={index}
            title={position.position}
            description={position.description}
          />
        ))}
        <SectionImage>
          <Image {...imageSerializer(props.image)} />
        </SectionImage>
      </PositionsContainer>
    </Section>
  );
};
